var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCould(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 40,
    viewBox: "0 0 96 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.68 28.367C81.7172 28.0398 81.7435 27.7104 81.7435 27.3719C81.7435 22.8094 78.1544 19.1111 73.7265 19.1111C72.4104 19.1111 71.1732 19.4427 70.0783 20.0227C66.9008 14.1785 60.8394 10.2297 53.8757 10.2297C52.7698 10.2297 51.6902 10.3357 50.6391 10.5275C48.1777 4.91347 42.7075 0.998535 36.3395 0.998535C27.67 0.998535 20.6428 8.23948 20.6428 17.1728C20.6428 17.2134 20.6494 17.2517 20.6494 17.2924C20.2946 17.272 19.9377 17.2563 19.5785 17.2563C9.31699 17.2563 1 25.8285 1 36.4C1 37.2687 1.07664 38.1194 1.18613 38.9588H94.9701C92.4627 33.5365 87.5663 29.5223 81.68 28.367Z",
    stroke: "#100A55",
    strokeOpacity: 0.15,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCould);
export default __webpack_public_path__ + "static/media/could.7f8529a382eb0a5c3394c858592b2ab2.svg";
export { ForwardRef as ReactComponent };